/**
 * Theme plumbing. The persisted choice is applied to <html data-theme> by an inline script in
 * index.html BEFORE first paint (no flash); this module owns reading/toggling it afterwards.
 * Dark is the default; light is the projector / bright-room presentation theme.
 */
export type Theme = 'dark' | 'light';

const KEY = 'fa-demo-theme';

export function currentTheme(): Theme {
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';
}

export function toggleTheme(): Theme {
  const next: Theme = currentTheme() === 'light' ? 'dark' : 'light';
  document.documentElement.dataset.theme = next;
  try {
    localStorage.setItem(KEY, next);
  } catch {
    /* private browsing — theme just won't persist */
  }
  return next;
}
